module.exports = __webpack_public_path__ + "static/media/Carrefour.ba9cbd6c.png";